import { Coordinate } from 'ol/coordinate';
import VectorSource from 'ol/source/Vector';

export abstract class IsavMapVectorSource {
    abstract toSourceCoordinate(coordinate: Coordinate): Coordinate;
    abstract fromSourceCoordinate(coordinate: Coordinate): Coordinate;
    abstract getVectorSource(): VectorSource;
    abstract center(coordinate: Coordinate): void;
}
